import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";

export interface WorkspaceSummary {
  id: string;
  slug: string;
  name: string;
  primaryEmail?: string | null;
  primaryPhone?: string | null;
  timezone?: string;
  logoUrl?: string | null;
  whatriteEnabled?: boolean;
  whatmailEnabled?: boolean;
  salesAutoClaim?: boolean;
}

interface ListResponse {
  workspaces: WorkspaceSummary[];
}

export function useWorkspaces(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["workspaces"],
    queryFn: () => apiClient.get<ListResponse>("/api/workspaces"),
    staleTime: 60_000,
    enabled: opts.enabled ?? true,
  });
}
